import {
  useEffect, useRef, useCallback, ReactElement,
} from 'react';
import {
  Container, Row, Col, Button,
} from 'react-bootstrap';
import moment from 'moment';
import { useParams, useNavigate } from 'react-router-dom';
import jwtDecode, { JwtPayload } from 'jwt-decode';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import { InputUnform, load } from '../../components';
import { api, alerts } from '../../utils';
import validarErroForm from './utils/validar-erro-form-change-pass';

interface TypeForm {
  senha: string;
  newPassword: string;
}

const ChangePassword = (): ReactElement => {
  const { token = '' } = useParams();

  const navigate = useNavigate();

  const formRef = useRef<FormHandles>(null);

  const verifyToken = useCallback(() => {
    const decoded: JwtPayload = jwtDecode(token);

    if (!decoded.exp) {
      navigate('/login', { replace: true });
      return;
    }

    const tokenExpired = moment.unix(decoded.exp);
    if (moment() > tokenExpired) {
      navigate('/login', { replace: true });
    }
  }, [token, navigate]);

  const handleForgotPassword = async (data: TypeForm) => {
    try {
      formRef.current?.setErrors({});

      await validarErroForm(data);

      load.show();

      verifyToken();
      await api.changePassword(data, token);

      alerts.exibirToastSuccess('Senha redefinida com sucesso');
      navigate('/login');
    } catch (error) {
      alerts.exibirErrorCatch(error, formRef);
    } finally {
      load.hide();
    }
  };

  useEffect(() => {
    verifyToken();
  }, [verifyToken]);

  return (
    <Container>
      <Row className="justify-content-center">
        <Col xl={6} lg={12} md={9}>
          <div className="card o-hidden border-0 shadow-lg my-5">
            <div className="card-body p-0">
              <Row>
                <Col lg={12}>
                  <div className="p-5">
                    <div className="text-center">
                      <h1 className="h4 text-gray-900 mb-2">
                        Alteração de senha:
                      </h1>
                      <p className="mb-4">
                        Digite sua nova senha
                      </p>
                    </div>
                    <Form ref={formRef} onSubmit={handleForgotPassword}>
                      <div className="form-group">
                        <InputUnform
                          key="forgot-password"
                          type="password"
                          name="senha"
                          className="form-control form-control-user"
                          placeholder="Nova senha"
                        />
                      </div>
                      <div className="form-group">
                        <InputUnform
                          key="forgot-password"
                          type="password"
                          name="newPassword"
                          className="form-control form-control-user"
                          placeholder="Repetir nova senha"
                        />
                      </div>
                      <Button
                        className="btn btn-primary btn-user btn-block"
                        variant="primary"
                        type="submit"
                      >
                        Alterar senha
                      </Button>
                    </Form>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ChangePassword;
